import { IJoinTextRelationalItemBean } from "../beans/items";
import { JoinTextRelationalItem } from "../../../../domain/document/items";

export class JoinTextRelationalItemTranslator {
  static toJoinTextRelationalItems(beans: IJoinTextRelationalItemBean[]): JoinTextRelationalItem[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toJoinTextRelationalItem(bean));
  }

  private static toJoinTextRelationalItem(bean: IJoinTextRelationalItemBean): JoinTextRelationalItem {
    return new JoinTextRelationalItem(bean.itemType, bean.objectId, bean.key, bean.value);
  }
}
